module.exports = __webpack_public_path__ + "static/reel-fence-3bf21ee9347f1accedbd6aa587d7777a.jpg";